import fetchData from "../../../shared/fetchData";

export const API_CHANGE_ORDER_RESERVATION =
  "management/api/v1/orders/changeOrderReservation";

export const buildPasswordPayload = (passwordExpires, passwordTypes) =>
  passwordTypes
    .map((type) => ({
      type: type,
      expireDate: passwordExpires[type]?.expireDate || "",
      expireTime: passwordExpires[type]?.expireTime || "",
    }))
    .filter((p) => p.expireDate && p.expireTime);

export const buildChangeReservationPayload = ({
  courierTrackNumbers,
  startDate,
  startTime,
  endDate,
  endTime,
  passwordExpires,
  passwordTypes,
}) => ({
  courierTrackNumbers: courierTrackNumbers.map((num) => String(num)),
  startDate,
  startTime,
  endDate,
  endTime,
  passwords: buildPasswordPayload(passwordExpires, passwordTypes),
  version: "mtpx001",
});

export const submitChangeOrderReservation = (payload) =>
  fetchData(JSON.stringify(payload), API_CHANGE_ORDER_RESERVATION).then(
    (response) => response.json()
  );

const VALIDATION_ERROR_MESSAGES = {
  INVALID_INPUT: "اطلاعات ورودی نامعتبر است",
  INVALID_DATE: "فرمت تاریخ نامعتبر است",
  INVALID_ORDER_DURATION: "بازه زمانی انتخاب‌شده نامعتبر است",
  GENERAL_ERROR: "خطا در انجام عملیات",
};

export const isOkStatus = (result) =>
  result?.status == 0 || result?.status === "0" || result?.message === "OK";

export const isPartialSuccess = (result) => result?.message === "PARTIAL_SUCCESS";

export const parseChangeReservationResponse = (result) => {
  const items = Array.isArray(result?.results) ? result.results : [];
  const totalCount =
    result?.totalCount != null ? result.totalCount : items.length;
  const successCount =
    result?.successCount != null
      ? result.successCount
      : items.filter((item) => item.success).length;
  const failedCount =
    result?.failedCount != null
      ? result.failedCount
      : items.filter((item) => !item.success).length;

  if (items.length === 0 && totalCount === 0) {
    return {
      kind: "validation_error",
      message:
        VALIDATION_ERROR_MESSAGES[result?.message] ||
        result?.message ||
        "خطا در ثبت تغییرات",
      items: [],
      totalCount: 0,
      successCount: 0,
      failedCount: 0,
    };
  }

  if (isOkStatus(result)) {
    return {
      kind: "success",
      message:
        successCount === 1
          ? "عملیات با موفقیت انجام شد"
          : `${successCount} سفارش با موفقیت به‌روزرسانی شد`,
      items,
      totalCount,
      successCount,
      failedCount,
    };
  }

  if (isPartialSuccess(result)) {
    return {
      kind: "partial",
      message: `${successCount} موفق و ${failedCount} ناموفق از ${totalCount} سفارش`,
      items,
      totalCount,
      successCount,
      failedCount,
    };
  }

  const firstError = items.find((item) => !item.success)?.errorMessage;

  return {
    kind: "all_failed",
    message: firstError || "هیچ سفارشی به‌روزرسانی نشد",
    items,
    totalCount,
    successCount,
    failedCount,
  };
};

export const notifyChangeReservationOutcome = (outcome, toast) => {
  switch (outcome.kind) {
    case "success":
      toast.success(outcome.message);
      break;
    case "partial":
      toast.warning(outcome.message);
      break;
    case "all_failed":
    case "validation_error":
      toast.error(outcome.message);
      break;
    default:
      toast.error("خطا در ثبت تغییرات");
  }
};
